<template>
  <div class="is-border-top">
    <sales-light-list :sales="contactReservations"></sales-light-list>
  </div>
</template>
<script>
import ContactMixin from '../ContactMixin'

export default {
  name: 'ContactReservations',
  components: {
    SalesLightList: () => import('@/components/adv/SalesLightList')
  },
  mixins: [ContactMixin],
  watch: {
    sourceContactReservations (v) {
      this.updateSources({ reservations: v })
    }
  }
}
</script>
